<template>
  <div class="container  detailPage padding15">
    <van-nav-bar title="活动详情" left-text fixed left-arrow @click-left="onClickLeft" />
    <van-skeleton title :row="15" :loading="skeletonLoading">
      <div class="topImg">
        <van-image fit="cover" :src="info.photoUrl" />
      </div>
      <van-row type="flex" justify="space-between" class="marginTop10 colorGrey1">
        <van-col span="18" class="namevan-ellipsis name">{{info.activityName}}</van-col>
        <van-col span="6" class="van-ellipsis textAlignRight">
          <van-tag color="#DBDBDB" round text-color="#333" v-if='info.isLongTerm'>{{info.isLongTerm==1?'长期':'临时'}}</van-tag>
          <van-tag color="#DBDBDB" round text-color="#333" v-if='info.typeName'>{{info.typeName}}</van-tag>
        </van-col>
      </van-row>
      <div class="comsumeList marginTop10" v-if='info.isConsume == 1'>
        可选套餐：
        <van-tag
          color="#ccc"
          round
          text-color="#fff"
          v-for="(item,index) in info.consumeTypeList"
          :key="index"
        >{{item.typeName}} {{item.money}}元</van-tag>
      </div>
       <div class="comsumeList marginTop10">
        活动类别：
        <van-tag
          :color="item.selected?'#d6253c':'#666'"
          type='danger'
          round
          :text-color="item.selected?'#fff':'#fff'"
          v-for="(item,index) in info.classifyList"
          :key="index"
          @click='handleSelectClassify(item,info)'
        >{{item.classify}}</van-tag>
      </div>
      <div class="comsumeList" v-if='info.isConsume == 2'>免费</div>
      <div class="time">开放时间：{{info.businessHours}}</div>
      <div class="address">地址：{{info.address}}</div>
      <van-row type="flex" justify="space-between" class="marginTop15 points">
        <van-col span="24" class="van-ellipsis">
          <i class="iconfont icon-jifen marginRight5" style="color:#ccc" />奖励积分：
          <span class="num">{{info.signUpIntegral}}</span>分 / 次
        </van-col>
      </van-row>
      <div class="concact">
        <div>
          <i class="iconfont icon-user fz18 marginRight5" style="color:#ccc" />
          联系人：{{info.linkPerson}}
        </div>
        <div>
          <i class="iconfont icon-dianhua fz18 marginRight5" style="color:#ccc" />
          电话：{{info.phone}}
        </div>
      </div>
      <van-tabs v-model="tabActive" scrollspy>
        <van-tab title="活动内容">
          <div class="ql-snow ql-editor">
            <div class="activity-main" v-html="info.content"></div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="fixedBtnGroup">
        <van-goods-action>
          <!-- 是否报名 (1.未收藏 2.收藏) -->
          <van-goods-action-button
            color="#2B2B41"
            type="warning"
            v-if="info.isCollection==1"
            text="收藏"
            icon="icon iconfont icon-favorite"
            @click="handleCollect"
          />
          <van-goods-action-button
            color="#2B2B41"
            type="warning"
            text="取消收藏"
            v-if="info.isCollection==2"
            icon="icon iconfont icon-favorite"

            @click="handleCollectCancel"
          />
          <!-- 临时活动有报名 -->
          <!-- isSignUp (1.未报名 2.报名) -->
          <van-goods-action-button
            color="#D6253C"
            type="danger"
            text="立即报名"
            v-if="info.isLongTerm ===2 && info.isSignUp ==1"
            @click="handleSignUp"
          />
          <van-goods-action-button
            color="#D6253C"
            type="danger"
            text="已报名"
            icon="passed"
            v-if="info.isLongTerm ===2 && info.isSignUp ==2"
          />
        </van-goods-action>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import { actDetail } from '@/api/activity'
import { collectCancel, collectAdd, actSignUp } from '@/api/data'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  data() {
    return {
      isCollected: false,
      info: '',
      tabActive: 0,
      skeletonLoading: true,
      classIdArr : [],
      classId:''
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getInfo() {
      let _this = this
      actDetail({ id: this.$route.query.id })
        .then((res) => {
          if (res) {
            if(_this.info.isSignUp == 2){
              _this.info.classifyList.forEach(item1 => {
                 _this.info.selectClassifyList.forEach(item2=> {
                   if(item1.id == item2.id){
                     item1.selected = true
                   }
                });
              });
            }
            _this.info = res.data
            document.title = _this.info.activityName
          }
          _this.skeletonLoading = false
        })
        .catch(() => {
          _this.skeletonLoading = false
        })
    },
    handleSelectClassify(item,info){
      if(info.isSignUp == 2){
        return
      }
      // item.selected = !item.selected
      this.$set(item,'selected',!item.selected)
    },
    // 报名
    handleSignUp() {
      let classIdArr = this.info.classifyList.filter(item=>{return item.selected})
      let classIds = classIdArr.map((item,index)=>{
        return item.id
      })
      if(classIds.length<1 ||classIds.length>2){
         this.$toast({
            message: '请选择1-2个活动类别',
          })
          return
      }
      let classIdsString = classIds.join(',')
      console.log(classIdsString)
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定报名当前活动吗？',
        })
        .then(() => {
          actSignUp({ activityId: this.$route.query.id,classId:classIdsString }).then((res) => {
            if (res) {
              this.$toast({
                message: '报名成功',
                position: 'bottom',
              })
              this.getInfo()
              this.$store.dispatch("getInfo")
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 收藏
    handleCollect() {
      collectAdd({ activityId: this.$route.query.id }).then((res) => {
        if (res) {
          this.$toast({
            message: '收藏成功',
            position: 'bottom',
          })
          this.getInfo()
        }
      })
    },
    handleCollectCancel() {
      collectCancel({ activityId: this.$route.query.id }).then((res) => {
        if (res) {
          this.$toast({
            message: '取消收藏成功',
            position: 'bottom',
          })
          this.getInfo()
        }
      })
    },
  },
}
</script>
